import { Edge, Node } from "reactflow"
import { ApiCell, SupabaseConnector } from "../database/SupabaseConnector"
import { UIEdge, UILogic, UISheet } from "../types/UITypes"
import { buildCellsDependencyTree } from "./buildCellDependencyTree"
import { canBeEvaluatedAsBoolean } from "./apiUtils"
import { CELL_CANNOT_BE_EVALUATED } from "./validationConstants"

export const getValidationForApi = (
  sheetId: string,
  uiNodes: Node<UISheet | UILogic>[],
  uiEdges: Edge<UIEdge>[],
  supabaseConnector: SupabaseConnector
) => {
  const api = supabaseConnector.getAPI(uiNodes, uiEdges, [], {
    [sheetId]: true,
  })

  const cellsDependencyTree = buildCellsDependencyTree(api)
  const errors: Record<string, Record<string, string>> = {}

  api.forEach((api) => {
    api.cells.forEach((cell) => {
      if (cell.columnIndex === 1 && cell.prev) {
        const apiCellDependencies = cellsDependencyTree[
          cell.id
        ].cellsData.filter(
          (dependencyCellData: ApiCell) => dependencyCellData.id !== cell.id
        )

        apiCellDependencies.forEach((cell: ApiCell) => {
          if (cell.sheetId) {
            if (!errors[cell.sheetId]) {
              errors[cell.sheetId] = {}
            }

            if (!canBeEvaluatedAsBoolean(cell)) {
              if (!errors[cell.sheetId][cell.id]) {
                errors[cell.sheetId][cell.id] = CELL_CANNOT_BE_EVALUATED
              }
            }
          }
        })
      }
    })
  })

  return errors
}
